






































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { MessageService, messages } from '@/api'
import helpers from '@/helpers'

@Component({ components: { PulseLoader } })
export default class ListUserMessages extends Vue {
  @Prop(String) id!: string

  public loaded = false
  public text = ''
  public sending = false
  public msgs: messages | null = null

  mounted (): void {
    this.updateMessages()
  }

  private updateMessages () {
    const id = helpers.getAmount(this.id)

    MessageService.getUserMessages({ id }).then((vals) => {
      this.msgs = vals
    }).finally(() => {
      this.loaded = true

      setTimeout(() => { this.updateMessages() }, 10000)
    })
  }

  formatDate (val: string | undefined): string {
    return helpers.formatDayNear(val)
  }

  public sendMessage () {
    this.sending = true

    const id = helpers.getAmount(this.id)

    MessageService.addUserMessage({ requestBody: { text: this.text, user_id: id } }).then((msg) => {
      this.text = ''

      if (!this.msgs) {
        this.msgs = [msg]
        return
      }

      this.msgs.unshift(msg)
    }).finally(() => {
      this.sending = false
    })
  }
}
